/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Portal_Copy_AccountInputs */

const en_booking_portal_copy_account = /** @type {(inputs: Booking_Portal_Copy_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy the account number`)
};

const pl_booking_portal_copy_account = /** @type {(inputs: Booking_Portal_Copy_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopiuj numer konta`)
};

/**
* | output |
* | --- |
* | "Copy the account number" |
*
* @param {Booking_Portal_Copy_AccountInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_copy_account = /** @type {((inputs?: Booking_Portal_Copy_AccountInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_Copy_AccountInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_copy_account(inputs)
	return en_booking_portal_copy_account(inputs)
});